/**
 * Flattens an employee_assignments row (with nested employee join)
 * into the same shape as the old employees table row.
 * This lets all downstream consumers work unchanged.
 *
 * Input shape (from PostgREST):
 *   { id, business_id, role_id, ..., employee: { id, name, email, ... }, positionInfo, roleInfo, ... }
 *
 * Output shape (matches Employee interface):
 *   { id (person), name, email, business_id, role_id, ..., assignment_id }
 */
export function flattenAssignment(row: any): any {
  if (!row?.employee) return row;

  const { employee, id: assignmentId, employee_id, ...assignment } = row;

  // Nested joins that live inside the employee object (children, garnishments)
  // need to be pulled up to the top level.
  const { children, garnishments, ...personFields } = employee;

  return {
    ...personFields,   // person fields first (id, name, email, user_id, ...)
    ...assignment,     // assignment fields second (role_id, business_id, hourly_rate, ...)
    id: personFields.id,        // ensure person ID is the top-level id
    assignment_id: assignmentId, // preserve the assignment row ID for updates
    // Re-attach nested joins at top level
    ...(children !== undefined && { children }),
    ...(garnishments !== undefined && { garnishments }),
  };
}

/**
 * Batch-flatten an array of assignment rows.
 */
export function flattenAssignments(rows: any[]): any[] {
  return (rows || []).map(flattenAssignment);
}
